export enum EvidenceAction {
  Print = 'print',
  Download = 'download',
  JustApprove = 'approve', // for backward compatibility with older localStorage values; can be removed in the future
}

/** Labels for the approve-and-generate-evidence actions shown before the event is approved. */
export const preApproveLabels: Record<EvidenceAction, string> = {
  [EvidenceAction.Print]: 'Approve and Print',
  [EvidenceAction.Download]: 'Approve and Download',
  [EvidenceAction.JustApprove]: 'Approve',
} as const;

/** Labels for the generate-evidence actions shown after the event is already approved. */
export const postApproveLabels: Record<EvidenceAction, string> = {
  [EvidenceAction.Print]: 'Print Evidence',
  [EvidenceAction.Download]: 'Download Evidence',
  [EvidenceAction.JustApprove]: 'Approved', // required by Record type; filtered out by useEvidenceActions at runtime
} as const;
